<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <el-skeleton-item variant="image" class="sk__image" />
      <div class="sk__inner">
        <el-skeleton-item variant="p" class="sk__name" />
        <el-skeleton-item variant="p" class="sk__price" />
        <div class="sk__bottom">
          <el-skeleton-item variant="p" class="sk__button" />
          <el-skeleton-item variant="p" class="sk__button" />
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  width: 225px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.61);
  border: 1px solid #EDEDED;
  overflow: hidden;

  &__image {
    width: 100%;
    height: 185px;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 12px;
  }

  &__name {
    width: 100%;
    height: 18px;
  }

  &__price {
    width: 50px;
    height: 18px;
  }

  &__bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__button {
    width: 40%;
    height: 29px;
  }
}

:deep(.el-skeleton__item) {
  --el-skeleton-color: #c9ccd0 !important;
  --el-skeleton-to-color: #c3c3c7 !important;
}
</style>